import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useRef
} from 'react';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import {
  GET_TASK_LIST,
  UPDATE_TICKET,
  savePersonalization,
  getPersonalization,
  TicketClient,
  UPDATE_TASK
} from '@nile/graphql';
import TicketKanbanCard from '@nile/mangifera/src/Containers/CardContainers/TicketKanbanCard';
import TaskKanbanCard from '@nile/mangifera/src/Containers/CardContainers/TaskKanbanCard';
import {
  AppContext,
  EventEmitter,
  Loader,
  rearrangeArrayValue,
  useIsAuthorisedHook,
  useSuperListHook,
  ALL_TABLES,
  ALL_MODULES,
  DEFAULT_FIELDS_BY_COLUMN_NAME
} from '@nile/components';
import { cloneDeep } from 'lodash';
import { ButtonGroup, Button } from '@superops/ui-design-system';
import { SuperBoard } from '@nile/components/src/react-super-kanban';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { TaskKanbanTabs } from '@nile/mangifera/src/Constants/Tickets';
import { KanbanLaneHeader } from '@nile/mangifera/src/Components/Ticket';
import { constructTaskObject } from '@nile/projects/src/Utils';
import {
  KanbanWrapper,
  HeaderContainer,
  StyledText
} from '@nile/mangifera/src/StyledComponents/KanbanBoardStyles';
import Queries from '@nile/mangifera/src/Queries';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { NewTaskModal } from '../../Components/Task/HTMLCell';

const ROW_COUNT = 20;
const TaskKanbanContainer = (props) => {
  const context = useContext(TicketContext);
  const contextRef = useRef();
  contextRef.current = context;
  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const user = {
    firstName: currentUser.firstName,
    userId: currentUser.userId,
    email: currentUser.email,
    lastName: currentUser.lastName
  };
  const { taskViews } = props;
  const [activeTab, setActiveTab] = useState(
    context?.activeTab?.state?.kanbanTab || 'technician'
  );
  const urlParams = new URLSearchParams(props.location.search);
  const taskIdParam = urlParams?.get('taskId');
  const moduleParam = urlParams?.get('module');
  const activeTabRef = useRef();
  activeTabRef.current = activeTab;
  const [isLoading, setIsLoading] = useState(true);
  const [kanbanLanes, setKanbanLanes] = useState([]);
  const defaultSort = {
    attribute: 'createdTime',
    order: 'DESC'
  };
  const [kanbanState, setKanbanState] = useState(
    context?.activeTab?.state?.kanbanSort || {}
  );
  const kanbanStateRef = useRef();
  kanbanStateRef.current = kanbanState;
  const [activeView, setActiveView] = useState(
    taskViews.find((item) => {
      return item.id === props.match.params.id;
    })
  );
  const activeViewRef = useRef();
  activeViewRef.current = activeView;
  const [pinnedColumns, setPinnedColumns] = useState({
    technician: ['Unassigned tickets'],
    group: ['Unassigned tickets'],
    status: [],
    priority: []
  });
  const { advanceFilterCondition } = useSuperListHook({
    tableName: ALL_TABLES.tasks,
    viewId: activeViewRef.current?.id
  });

  const flags = useFlags();
  const [technicians, setAllTechnicians] = useState([]);
  const [technicianGroups, setAllTechnicianGroups] = useState([]);
  const [priorities, setAllPriorities] = useState([]);
  const [statuses, setAllStatus] = useState([]);
  const [displayLaneCount, setDisplayLaneCount] = useState(10);
  const IntialMap = {
    technician: true
  };

  const [closureModalactive, setClosureModalActive] = useState(false);
  const [closureSaveLoading, setClosureSaveLoading] = useState(false);

  const [errorsOnClosure, setErrorsOnClosure] = useState(null);
  const errorsOnClosureByRef = React.useRef(null);
  errorsOnClosureByRef.current = errorsOnClosure;

  const getClosureFields = (errorFields) => {
    setClosureModalActive(true);
    setErrorsOnClosure({
      ticket: errorFields?.param?.ticket,
      status: errorFields?.param?.status,
      fields: errorFields?.param?.fields
    });
  };

  useEffect(() => {
    EventEmitter.subscribe('ticketClosureError', getClosureFields);
    return function cleanup() {
      EventEmitter.unsubscribe('ticketClosureError');
    };
  });

  const getColumnSortData = () => {
    getPersonalization({
      userId: currentUser?.userId,
      category: 'TaskKanbanViewPersonalization',
      name: activeView?.id
    })
      .then((response) => {
        if (response) {
          const res = response?.data?.getPersonalizationByCategoryAndName;
          if (res !== null) {
            setKanbanState(JSON.parse(res.value));
          } else {
            setKanbanState({});
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateTicket = (
    source,
    target,
    item,
    board,
    dispatch,
    updatedBoard
  ) => {
    const { ticketId, taskId } = item;
    const updateObjectMap = {
      status: {
        status: statuses.find((el) => el.id === target)?.name || null
      },
      priority: {
        priority: priorities.find((el) => el.id === target)?.name || null
      },
      technician: {
        technician: target === 'Unassigned tickets' ? null : { userId: target }
      },
      group: {
        techGroup:
          target === 'Unassigned tickets'
            ? null
            : {
                groupId: target
              },
        technician: null
      }
    };
    if (source !== target) {
      TicketClient.mutate({
        mutation: UPDATE_TASK,
        variables: {
          taskId: taskId,
          module: item.workItem.module,
          input: { ...updateObjectMap[activeTab] }
        }
      })
        .then((res) => {
          if (res?.data?.updateTask) {
            const newUpdatedTask = res?.data?.updateTask;
            const newBoardData = cloneDeep(updatedBoard);
            const sourceLaneIdx = newBoardData.findIndex(
              (el) => el.id === source
            );
            const targetLaneIdx = newBoardData.findIndex(
              (el) => el.id === target
            );
            newBoardData[sourceLaneIdx].count -= 1;
            newBoardData[targetLaneIdx].count += 1;
            const itemToUpdate = newBoardData[targetLaneIdx].items.findIndex(
              (el) => el.taskId === newUpdatedTask.taskId
            );
            newBoardData[targetLaneIdx].items[itemToUpdate] = {
              ...newBoardData[targetLaneIdx].items[itemToUpdate],
              ...newUpdatedTask
            };
            dispatch({ type: 'resetBoard', board: newBoardData });
          } else {
            dispatch({ type: 'resetBoard', board: board });
          }
        })
        .catch((err) => {
          // toast('error', 'Something went wrong');
          callback && callback();
        });
    }
  };

  const attributeMap = {
    technician: 'technician.userId',
    group: 'techGroup.name',
    status: 'status',
    priority: 'priority'
  };
  const getOperandsList = (id) => {
    const conditions = advanceFilterCondition?.operands || [];
    return conditions.concat([
      {
        attribute: attributeMap[activeTab],
        operator: id ? 'is' : 'isEmpty',
        value: id || ''
      }
    ]);
  };
  const fetchTasks = async (id, params = { page: 1, pageSize: ROW_COUNT }) => {
    const sortData = kanbanState?.[activeTab]
      ? kanbanState?.[activeTab]
      : defaultSort;
    const res = await TicketClient.query({
      query: GET_TASK_LIST,
      variables: {
        listInfo: {
          view: { id: activeView.id },
          page: params.page,
          pageSize: params.pageSize,
          condition: {
            joinOperator: 'AND',
            operands: getOperandsList(id)
          },
          sort: [sortData]
        }
      },
      fetchPolicy: 'network-only'
    });
    if (res?.data?.getTasks?.tasks) {
      return {
        cards: res?.data?.getTasks?.tasks.map((task) => ({
          ...task,
          id: task.taskId
        })),
        count: res?.data?.getTasks?.listInfo.totalCount
      };
    }
    return [];
  };
  const handlePagination = async (requestedPage, laneId, board) => {
    const refMap = {
      technician: technicians,
      priority: priorities,
      status: statuses,
      group: technicianGroups
    };
    const keyMap = {
      technician: 'id',
      priority: 'name',
      status: 'name',
      group: 'name'
    };
    const currentLaneIndex = board.findIndex((el) => el.id === laneId);
    const currentLane = board[currentLaneIndex];
    const totalCount = currentLane.count;
    if ((requestedPage - 1) * ROW_COUNT < totalCount) {
      const ref = refMap[activeTab];
      const key = keyMap[activeTab];
      const name = ref.find((el) => el.id === laneId)?.[key];
      const taskResponse = await fetchTasks(name, {
        page: requestedPage,
        pageSize: ROW_COUNT
      });
      return taskResponse.cards;
    }
    return [];
  };
  const togglePinnedColumns = (action, board) => {
    if (action.type === 'pinColumn' || action.type === 'unpinColumn') {
      const { data: colData } = action.meta;
      const { id: columnId } = colData;
      const personalisedData = {
        user: user,
        name: 'kanbanPinnedColumns',
        category: 'TaskKanbanView'
      };
      let updatedPinnedColumns = [];
      if (action.type === 'unpinColumn') {
        updatedPinnedColumns = [...pinnedColumns?.[activeTab]].filter(
          (col) => col !== columnId
        );
      } else if (action.type === 'pinColumn') {
        updatedPinnedColumns = [...pinnedColumns?.[activeTab], columnId];
      }
      setPinnedColumns({ ...pinnedColumns, [activeTab]: updatedPinnedColumns });
      personalisedData.value = JSON.stringify({
        ...pinnedColumns,
        [activeTab]: updatedPinnedColumns
      });
      savePersonalization({
        variables: personalisedData,
        input: personalisedData
      });
    }
  };
  const tabDataMap = {
    technician: {
      id: 'userId',
      laneId: 'userId',
      unassignedTicket: true,
      getData: Queries.getAllTechnicians,
      setData: setAllTechnicians
    },
    group: {
      id: 'groupId',
      unassignedTicket: true,
      getData: Queries.getAllTechnicianGroups,
      setData: setAllTechnicianGroups
    },
    status: {
      getData: Queries.getAllWorkStatus,
      setData: setAllStatus
    },
    priority: {
      getData: Queries.getAllPrioritiesTask,
      setData: setAllPriorities
    }
  };
  const reorderLanes = (lanes) => {
    Queries.getPinnedColumnData(currentUser?.userId, 'TaskKanbanView').then(
      (res) => {
        const getPersonalizationByCategoryAndName =
          res?.data?.getPersonalizationByCategoryAndName;
        let personalisedPinnedColumns = {};
        if (getPersonalizationByCategoryAndName) {
          personalisedPinnedColumns = JSON.parse(
            getPersonalizationByCategoryAndName?.value
          );
          personalisedPinnedColumns &&
            setPinnedColumns({
              ...pinnedColumns,
              ...personalisedPinnedColumns
            });
        }

        Queries.getColumnOrder(
          activeTabRef.current,
          currentUser?.userId,
          'TaskKanbanView'
        ).then((colData) => {
          if (colData?.length) {
            setDisplayLaneCount(colData.length);
            colData.forEach((colId, i) => {
              const columnIdx = lanes.findIndex((lane) => lane?.id === colId);
              if (columnIdx > -1) {
                rearrangeArrayValue(lanes, columnIdx, i);
              }
            });
          } else {
            setDisplayLaneCount(10);
          }
          if (personalisedPinnedColumns?.[activeTabRef.current]?.length) {
            personalisedPinnedColumns?.[activeTabRef.current]?.forEach(
              (colId, i) => {
                const columnIdx = lanes.findIndex((lane) => lane?.id === colId);
                if (columnIdx > -1) {
                  rearrangeArrayValue(lanes, columnIdx, i);
                }
              }
            );
          }
          setKanbanLanes(lanes);
          setIsLoading(false);
        });
      }
    );
  };
  const updateTask = (updatedTask, taskId, args, callback) => {
    const taskObj = constructTaskObject(updatedTask);
    TicketClient.mutate({
      mutation: UPDATE_TASK,
      variables: {
        taskId: taskId,
        module: args.ticket ? 'TICKET' : 'PROJECT',
        input: taskObj
      }
    })
      .then((res) => {
        if (res?.data?.updateTask) {
          updateMyData(res.data.updateTask);
          toast('success', 'Task updated successfully');
          callback && callback();
        }
      })
      .catch((err) => {
        // toast('error', 'Something went wrong');
        callback && callback();
      });
  };

  const deleteTask = (taskId, args, callback) => {
    TicketClient.mutate({
      mutation: DELETE_TASK,
      variables: {
        taskId: taskId,
        module: args.ticket ? 'TICKET' : 'PROJECT'
      }
    })
      .then((res) => {
        if (res?.data?.deleteTask) {
          fetchViewData();
          toast(
            'success',
            getTranslatedText(intl, 'ticket.details.task.delete.success')
          );
          callback && callback();
        }
      })
      .catch((err) => {
        // toast('error', 'Something went wrong');
        callback && callback();
      });
  };
  const constructLanes = (tab) => {
    setIsLoading(true);
    const currentTabData = tabDataMap[tab];
    currentTabData?.getData().then((res) => {
      currentTabData?.setData(res);
      let lanes = res?.map((el) => {
        return {
          id: el[currentTabData?.id || 'id'],
          title: el[currentTabData?.title || 'name'],
          laneId: el[currentTabData?.laneId || 'name']
        };
      });
      currentTabData?.unassignedTicket &&
        lanes?.unshift({
          id: 'Unassigned tickets',
          title: `ticket.kanban.unassignedTickets.${tab}`
        });
      reorderLanes(lanes);
    });
  };
  const setLanes = () => {
    constructLanes(activeTab);
  };
  const saveKanbanSort = useCallback(
    (sortData) => {
      const currentState = {
        ...kanbanStateRef.current,
        [activeTabRef.current]: sortData
      };
      setKanbanState(currentState);
      const personalisedData = {
        name: activeViewRef.current?.id,
        category: 'TaskKanbanViewPersonalization',
        value: JSON.stringify(currentState),
        user: user
      };
      savePersonalization({
        variables: personalisedData,
        input: personalisedData
      });
    },
    [
      activeTabRef.current,
      kanbanStateRef.current,
      activeViewRef.current,
      currentUser
    ]
  );
  const saveBoard = (board) => {
    const personalisedData = {
      user: user,
      name: activeTabRef.current,
      category: 'TaskKanbanView'
    };
    const columnOrderNew = board.map((col) => col.id);
    personalisedData.value = JSON.stringify(columnOrderNew);
    // save the board data in personalisation
    savePersonalization({
      variables: personalisedData,
      input: personalisedData
    });
  };
  const boardChangeHandler = (action, board) => {
    switch (action.type) {
      case 'moveList':
      case 'addList':
      case 'addLists':
      case 'unpinColumn':
      case 'removeFromList':
        saveBoard(board);
        break;
      default:
        break;
    }
  };

  const getListItems = async (params) => {
    const { list } = params;
    const taskResponse = await fetchTasks(list.laneId);
    return new Promise((resolve) => {
      resolve(
        {
          items: taskResponse.cards,
          params: { count: taskResponse.count }
        } || { items: [] }
      );
    });
  };
  const handleTabChange = ({ id }) => {
    context.setActiveKanbanTab(id);
    setActiveTab(id);
  };
  // let isProjectEditAuthorised = useIsAuthorisedHook('task.edit');
  // const isTicketEditAuthorized = useIsAuthorisedHook('tickets.edit');
  const isCardDragRestrictedCheck = ({ cardData }) => {
    // let isEditAuthorised = true;
    // if (cardData?.ticket || cardData?.project) {
    //   let isTicketEditAuthorisedNew;
    //   if (
    //     cardData?.ticket?.loggedInUserAsFollower?.ticketPermission ||
    //     cardData?.ticketPermission
    //   ) {
    //     isTicketEditAuthorisedNew =
    //       cardData?.technician?.userId === currentUser?.userId;
    //   } else {
    //     isTicketEditAuthorisedNew = isTicketEditAuthorized;
    //   }
    //   if (
    //     !!cardData?.project &&
    //     cardData?.technician?.userId === currentUser?.userId
    //   ) {
    //     isProjectEditAuthorised =
    //       cardData?.technician?.userId === currentUser?.userId;
    //   }
    //   isEditAuthorised = cardData?.ticket
    //     ? isTicketEditAuthorisedNew
    //     : isProjectEditAuthorised;
    // }
    // return !isEditAuthorised;
    return false;
  };
  const activePinnedColumns = pinnedColumns?.[activeTab] || [
    'Unassigned tickets'
  ];
  useEffect(() => {
    setLanes();
  }, [activeTab, advanceFilterCondition]);

  useEffect(() => {
    if (activeView) {
      setLanes();
      getColumnSortData();
    }
  }, [activeView]);

  useEffect(() => {
    const newActiveView = taskViews.find((item) => {
      return item.id === props.match.params.id;
    });
    context.setActiveView(newActiveView);
    setActiveView(newActiveView);
  }, [props.match.params.id]);

  useEffect(() => {
    EventEmitter.dispatch('refreshBoard', {});
  }, [kanbanState]);

  useEffect(() => {
    getColumnSortData();
    // getPinnedColumnData();
    context.setPersonalization('');
    if (!context.activeKanbanTab) {
      context.setActiveKanbanTab('technician');
    }
    EventEmitter.subscribe('kanbanSort', saveKanbanSort);
    return function cleanup() {
      EventEmitter.unsubscribe('kanbanSort');
    };
  }, []);

  const initial = !!IntialMap?.[activeTabRef?.current];

  return (
    <KanbanWrapper>
      <HeaderContainer data-qa="kanbanViews">
        <StyledText>
          <FormattedMessage id="GROUP TASKS BY" />
        </StyledText>
        <ButtonGroup>
          {TaskKanbanTabs.map((tab) => (
            <Button
              outline={activeTab === tab.id}
              plain={activeTab !== tab.id}
              monochrome
              onClick={() => handleTabChange(tab)}
            >
              <div data-qa={tab.qa}>
                <FormattedMessage id={tab.label} />
              </div>
            </Button>
          ))}
        </ButtonGroup>
      </HeaderContainer>
      {isLoading ? (
        <div className="full-height full-width">
          <Loader />
          {/* <KanbanLoading /> */}
        </div>
      ) : (
        <>
          <SuperBoard
            lists={kanbanLanes}
            getListItems={getListItems}
            displayLaneCount={displayLaneCount}
            onLaneScroll={(requestedPage, laneId, board) => {
              const newCards = handlePagination(requestedPage, laneId, board);
              return new Promise((resolve) => {
                resolve(newCards);
              });
            }}
            middleWares={[togglePinnedColumns]}
            sideEffects={[boardChangeHandler]}
            onCardDrop={(
              sourceId,
              targetId,
              item,
              board,
              dispatch,
              updatedBoard
            ) => {
              updateTicket(
                sourceId,
                targetId,
                item,
                board,
                dispatch,
                updatedBoard
              );
            }}
            pinColumns
            reorderColumns
            pinnedColumns={activePinnedColumns}
            initial={initial}
            restrictCardDragCheck={isCardDragRestrictedCheck}
            components={{
              Card: (otherProps) => (
                <TaskKanbanCard
                  context={context}
                  {...otherProps}
                  setLanes={setLanes}
                  activeTab={activeTab}
                />
              ),
              ListHeader: (otherProps) => (
                <KanbanLaneHeader
                  {...otherProps}
                  setLanes={setLanes}
                  activeTab={activeTab}
                />
              )
            }}
          />
          {taskIdParam && moduleParam && (
            <NewTaskModal
              taskId={taskIdParam}
              module={moduleParam}
              actions={{
                updateTask: updateTask,
                deleteTask: deleteTask
              }}
            />
          )}
        </>
      )}
    </KanbanWrapper>
  );
};
export default withRouter(injectIntl(TaskKanbanContainer));
